import { SafeNavigate } from '@/services/router/safe-navigate';

/**
 * AI-off accounts reaching the wizard URL directly. Sent home rather than
 * shown an empty state, so the takeover can't dead-end them.
 */
export function OnboardingWizardFallback() {
  return <SafeNavigate to="/" options={{ shouldReplaceHistoryEntry: true }} />;
}
